import { Common } from './common';
import { PatientPCP } from './models/previsit/patient/careTeam';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getPatientCareTeam(previsitFormFieldId: string): Promise<PatientPCP[]> {
    const url = this.common.constructPath(
      `/patient-previsit/patient-care-team`,
      { previsitFormFieldId },
    );
    return this.common.getJSON(url, undefined, true);
  }
}
